// extracted by mini-css-extract-plugin
export default {"container":"Kq8uK6"};